// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__MQWpO","contentRight":"style_contentRight__1t4Ar","contentRightMg":"style_contentRightMg__2A1hl"};